export default __webpack_public_path__ + "static/media/NoOneInOE-inner-page-2.2487d914.jpg";